/** 我的页面用到的小工具：年级名称、绑定码解析、复制到剪贴板 */
import { toast } from "../../core";

export const GRADES = ["K", "G1", "G2", "G3", "G4", "G5", "G6"] as const;

const GRADE_NAMES: Record<string, string> = { K: "幼儿园", G1: "一年级", G2: "二年级", G3: "三年级", G4: "四年级", G5: "五年级", G6: "六年级" };

export function gradeName(g: string): string {
  return GRADE_NAMES[g] ?? g;
}

/** 解析 kidsplanner://bind?c=<code>，也接受直接输入的绑定码（与 iOS BindCode.parse 一致）；不认识返回 null */
export function parseBindCode(text: string): string | null {
  const s = text.trim();
  if (/^kidsplanner:/i.test(s)) {
    const m = /^kidsplanner:\/\/bind\/?(?:\?(.*))?$/i.exec(s);
    if (!m) return null;
    const c = new URLSearchParams(m[1] ?? "").get("c");
    return c ? c : null;
  }
  return /^[\p{L}\p{N}_-]{1,64}$/u.test(s) ? s : null;
}

/** 复制文字；navigator.clipboard 不可用（非安全上下文）时退回 execCommand。成功后提示 */
export async function copyText(text: string, success = "已复制"): Promise<boolean> {
  let ok = false;
  try {
    await navigator.clipboard.writeText(text);
    ok = true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      ok = document.execCommand("copy");
    } catch {
      ok = false;
    }
    ta.remove();
  }
  toast(ok ? success : "复制失败，请手动选择文字复制", { error: !ok });
  return ok;
}
